import _JSXStyle from "styled-jsx/style";
import { Layer } from '@dhis2-ui/layer';
import { Popper } from '@dhis2-ui/popper';
import { colors, elevations } from '@dhis2/ui-constants';
import PropTypes from 'prop-types';
import React from 'react';

const MenuWrapper = _ref => {
  let {
    children,
    dataTest,
    maxHeight,
    menuWidth,
    onClick,
    selectRef
  } = _ref;
  return /*#__PURE__*/React.createElement(Layer, {
    onBackdropClick: onClick,
    transparent: true
  }, /*#__PURE__*/React.createElement(Popper, {
    reference: selectRef,
    placement: "bottom-start",
    observeReferenceResize: true
  }, /*#__PURE__*/React.createElement("div", {
    "data-test": "".concat(dataTest, "-menuwrapper"),
    className: _JSXStyle.dynamic([["1363246346", [menuWidth, maxHeight, colors.white, colors.grey200, elevations.e300]]])
  }, children, /*#__PURE__*/React.createElement(_JSXStyle, {
    id: "1363246346",
    dynamic: [menuWidth, maxHeight, colors.white, colors.grey200, elevations.e300]
  }, ["div.__jsx-style-dynamic-selector{width:".concat(menuWidth, ";height:auto;max-height:").concat(maxHeight, ";overflow:auto;background:").concat(colors.white, ";border:1px solid ").concat(colors.grey200, ";border-radius:3px;box-shadow:").concat(elevations.e300, ";}")]))));
};

MenuWrapper.defaultProps = {
  maxHeight: '280px'
};
MenuWrapper.propTypes = {
  dataTest: PropTypes.string.isRequired,
  menuWidth: PropTypes.string.isRequired,
  selectRef: PropTypes.object.isRequired,
  children: PropTypes.node,
  maxHeight: PropTypes.string,
  onClick: PropTypes.func
};
export { MenuWrapper };